import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import About from '@/components/About'
import Faq from '@/components/Faq'
import Services from '@/components/Services'
import Topics from '@/components/Topics'
import Main from '@/components/topics/Main'
import Business from '@/components/topics/Business'
import Leadership from '@/components/topics/Leadership'
import Management from '@/components/topics/Management'
import Team from '@/components/topics/Team'
import Evaluation from '@/components/Evaluation'
import Contact from '@/components/Contact'

Vue.use(Router)

export default new Router({
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/about',
      name: 'About',
      component: About
    },
    {
      path: '/faq',
      name: 'Faq',
      component: Faq
    },
    {
      path: '/services',
      name: 'Services',
      component: Services
    },
    {
      path: '/topics',
      name: 'Topics',
      component: Topics,
      children: [
        {
          path: '/',
          name: 'Main',
          component: Main
        },
        {
          path: 'business',
          name: 'services:business',
          component: Business
        },
        {
          path: 'leadership',
          name: 'services:leadership',
          component: Leadership
        },
        {
          path: 'management',
          name: 'services:management',
          component: Management
        },
        {
          path: 'team',
          name: 'services:team',
          component: Team
        }
      ]
    },
    {
      path: '/evaluation',
      name: 'Evaluation',
      component: Evaluation
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js